/**
 * @generated SignedSource<<0a99b5771c2326b275543886559dc3ca>>
 * @relayHash f0f958ebdc206ec225be6fc12de3956d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 71e0e1bec419b0d916f639a1da879bf2df3ece36a7031439c655ab8412a81b9c

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation$variables = {
  cloudId: string;
};
export type absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation$data = {
  readonly jira: {
    readonly devOps: {
      readonly optoutOfDevOpsIssuePanelNotConnectedState: {
        readonly errors: ReadonlyArray<{
          readonly extensions: {
            readonly __typename: "GenericMutationErrorExtension";
            readonly statusCode: number | null | undefined;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined;
          readonly message: string | null | undefined;
        }> | null | undefined;
        readonly success: boolean;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation = {
  response: absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation$data;
  variables: absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "statusCode"
    }
  ],
  "type": "GenericMutationErrorExtension"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsMutation",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraOptoutDevOpsIssuePanelNotConnectedPayload",
                "kind": "LinkedField",
                "name": "optoutOfDevOpsIssuePanelNotConnectedState",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsMutation",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraOptoutDevOpsIssuePanelNotConnectedPayload",
                "kind": "LinkedField",
                "name": "optoutOfDevOpsIssuePanelNotConnectedState",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ],
                            "type": "BulkMutationErrorExtension"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "71e0e1bec419b0d916f639a1da879bf2df3ece36a7031439c655ab8412a81b9c",
    "metadata": {},
    "name": "absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0189524f2e02f5faf49500efb2d22c19";

export default node;
